import { registerPropertyManagerSection } from '@/core';
import FilletPropertySection from '@/components/editor/property-manager/blend/FilletPropertySection.vue';

registerPropertyManagerSection({
  id: 'fillet-feature',
  title: '圆角',
  order: 32,
  component: FilletPropertySection,
  actions: {
    confirm: true,
    cancel: true,
  },
  resolveConfirmDisabled: (context) => context.filletCanSubmit === false,
  isApplicable: (context) => {
    if (context.activeCommand === 'fillet') {
      return true;
    }
    return context.filletActive === true;
  },
  onConfirm: (context) => {
    void context.submitFillet?.();
  },
  onCancel: (context) => {
    context.cancelBlend?.();
  },
});
